module.exports = __webpack_public_path__ + "img/Icon Raw Data.125ddb27.svg";